@if(showStatus) {
<th style="width:3%" pSortableColumn="hasAlert">
  <div class="flex items-center justify-center gap-1 font-semibold">
    <i class="pi pi-exclamation-triangle"></i>
    <p-sort-icon field="hasAlert" />
  </div>
</th>
}
<th style="width:15%" pSortableColumn="name">
  <div class="flex items-center justify-center gap-1 font-semibold">
    <span>{{ 'name' | translate }}</span>
      <p-sort-icon field="name" />
</div>
</th>
<th style="width:10%" pSortableColumn="metrics.date">
  <div class="flex items-center justify-center gap-1 font-semibold">
    <span>{{ 'parameters.metrics' | translate }}</span>
      <p-sort-icon field="metrics.date" />
</div>
</th>
<th style="width:15%">
  <div class="flex flex-col items-center justify-center font-semibold">
    <span>{{ 'parameters.monitor' | translate }}</span>
    <span class="text-xs font-normal">[hh:mm]</span>
  </div>
</th>
<th style="width:5%"></th>
<th style="width:12%">
  <div class="flex flex-col items-center justify-center font-semibold">
    <span>{{ 'parameters.heartrate' | translate }}</span>
    <div class="grid grid-cols-2 items-center text-xs font-normal">
      <span class="justify-self-center">bpm</span>
      <span class="justify-self-center">{{ 'parameters.media' | translate }}</span>
    </div>
  </div>
</th>
<th style="width:12%">
  <div class="flex flex-col items-center justify-center font-semibold">
    <span>{{ 'parameters.breathfrequency' | translate }}</span>
    <div class="grid grid-cols-2 items-center text-xs font-normal">
      <span class="justify-self-center">rpm</span>
      <span class="justify-self-center">{{ 'parameters.media' | translate }}</span>
    </div>
  </div>
</th>
@if(showSteps) {
<th style="width:7%">
  <div class="flex items-center justify-center font-semibold">
    <span>{{ 'parameters.steps' | translate }}</span>
  </div>
</th>
}
<th style="width:10%" pSortableColumn="report">
  <div class="flex items-center justify-center gap-1 font-semibold">
    <span>{{ 'parameters.reportLast' | translate }}</span>
    <p-sort-icon field="report" />
  </div>
</th>
<th style="width:5%"></th>
